@if (FromURL) {
<c-toaster class="p-3" position="fixed" [placement]="placement" />
}

<c-row class="d-flex justify-content-center">
  <c-col [lg]="FromURL ? 8 : 10">
    <c-card class="mb-3" *ngIf="!FromURL">
      <c-card-body>
        <c-row>
          <c-col [md]="6">
            <button
              cButton
              color="primary"
              variant="ghost"
              size="sm"
              (click)="goBack()"
              style="margin-right: 10px"
            >
              <svg cIcon name="cilArrowThickLeft"></svg>
            </button>
          </c-col>
          <c-col [md]="6" class="d-flex justify-content-end">
            <div>
              <button
                cButton
                color="secondary"
                variant="outline"
                (click)="generatePDFForInvoice(InvoiceDetailsData)"
              >
                Download PDF
                <svg cIcon name="cilSave"></svg>
              </button>
            </div>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>

    <c-card class="mb-4 shadow">
      <c-card-body>
        <c-row>
          <c-col [md]="6">
            <img
              src="assets/brand/x2xLogo.png"
              alt="X2X Logo"
              style="width: 250px; height: auto"
            />
          </c-col>
          <c-col
            [md]="6"
            class="d-flex justify-content-center align-items-center"
          >
            <p
              *ngIf="InvoiceDetailsData?.isPaid; else unpaid"
              style="color: green; font-size: 2em; font-weight: bold"
              class="align-self-center"
            >
              PAID
            </p>
            <ng-template #unpaid>
              <p
                style="color: red; font-size: 2em; font-weight: bold"
                class="align-self-center"
              >
                UNPAID
              </p>
            </ng-template>
          </c-col>
        </c-row>
        <hr />
        <c-row class="mx-3">
          <!-- <c-col>
            <h4 class="mt-3">Invoice # {{InvoiceDetailsData?.totalAmount}}</h4>
          </c-col> -->
          <c-col [md]="6" *ngIf="!InvoiceDetailsData?.o_IsBillToClient || fromportal">
            <p style="font-weight: bold; margin: 0">Bill To:</p>
            <p style="margin: 0">{{ UsersService.BusinessInfoData.legalName }}</p>
            <p style="margin: 0">
              {{ UsersService.BusinessInfoData.streetAddr }} ,
              {{ UsersService.BusinessInfoData.city }}
            </p>
            <p style="margin: 0">
              {{ UsersService.BusinessInfoData.state }} ,
              {{ UsersService.BusinessInfoData.zipCode }},
              {{ UsersService.BusinessInfoData.country }}
            </p>
            <p style="margin: 0">
              {{ UsersService.BusinessInfoData.phoneNo }}
            </p>
            <p style="margin: 0">
              {{ UsersService.BusinessInfoData.emailAddress }}
            </p>
            
          </c-col>
         
          <c-col [md]="6" *ngIf="InvoiceDetailsData?.o_IsBillToClient && !fromportal">
            <p style="font-weight: bold; margin: 0">Bill To:</p>
            <p style="margin: 0">{{ InvoiceDetailsData?.partnerExtraInfo?.companyName }}</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.partnerExtraInfo?.addr_Street }} ,
              {{ InvoiceDetailsData?.partnerExtraInfo?.addr_City }}
            </p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.partnerExtraInfo?.addr_State }} ,
              {{ InvoiceDetailsData?.partnerExtraInfo?.addr_ZipCode }},
              {{ InvoiceDetailsData?.partnerExtraInfo?.addr_Country }}
            </p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.partnerExtraInfo?.contactPersonPhone }}
            </p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.partnerExtraInfo?.contactPersonPhone }}
            </p>
          
          </c-col>
          <c-col [md]="6" class="text-end">
            <p style="font-weight: bold; margin: 0">Pay To:</p>
            <p style="margin: 0">x2x-eCommerce</p>
            <p style="margin: 0">2855 Markham Road, Suite 110,</p>
            <p style="margin: 0">Toronto, ON M1X 0C3, Canada</p>
            <p style="margin: 0">1-888-929-3266</p>
            <p style="margin: 0">{{ " info@x2x-ecommerce.com" }}</p>
          </c-col>
        </c-row>

        <c-row class="mx-3 mt-4">
          <c-col [md]="3">
            <p style="font-weight: bold; margin: 0">Invoice No:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.docRefNo }}
            </p>
          </c-col>
          <c-col [md]="3">
            <p style="font-weight: bold; margin: 0">Product Name:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.invoice_Details[0]?.productName }}
            </p>
          </c-col>
          <c-col [md]="3">
            <p style="font-weight: bold; margin: 0">Client Name:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.o_CompanyName }}
            </p>
          </c-col>
          <c-col [md]="3">
            <p style="font-weight: bold; margin: 0">Plan:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.plan?.planName }}
            </p>
          </c-col>
        
        </c-row>
        <c-row class="mx-3 mt-4">
          <c-col [md]="3">
            <p style="font-weight: bold; margin: 0">Invoice Date:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.invoiceDate | date : "MM/dd/yyyy" }}
            </p>
          </c-col>
          <c-col [md]="3" >
            <ng-container *ngIf="InvoiceDetailsData?.extraStores > 0">
            <p style="font-weight: bold; margin: 0">Extra Stores:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.extraStores }}
            </p>
            </ng-container>
          </c-col>
          
          <c-col [md]="6" *ngIf="InvoiceDetailsData?.isPaid" class="text-end">
            <p style="font-weight: bold; margin: 0">Paid Date:</p>
            <p style="margin: 0">
              {{ InvoiceDetailsData?.paymentDate | date : "MM/dd/yyyy" }}
            </p>
          </c-col>

          <c-col
            [md]="6"
            class="d-flex justify-content-end"
            *ngIf="!InvoiceDetailsData?.isPaid && !IsAdmin && InvoiceDetailsData?.isRecurring"
          >
            <div class="d-grid gap-2 col-6">
              <p style="font-weight: bold; margin: 0">Will Auto Pay On:</p>
              <p style="margin: 0">
                {{ InvoiceDetailsData?.invoiceDueDate | date : "MM/dd/yyyy" }}
              </p>
            </div>
          </c-col>
          <!-- <c-col
            [md]="6"
            class="d-flex justify-content-end"
            *ngIf="!InvoiceDetailsData?.isPaid && !IsAdmin &&  InvoiceDetailsData?.o_IsBillToClient && fromportal"
          >
            <div class="d-grid gap-2 col-6">
              <button
                cButton
                color="success"
                style="color: white"
                
              >
              To be Paid by the Client
              </button>
             
              
            </div>
          </c-col> -->
          
          <c-col
            [md]="6"
            class="d-flex justify-content-end"
            *ngIf="!InvoiceDetailsData?.isPaid && !IsAdmin && !InvoiceDetailsData?.isRecurring && (InvoiceDetailsData?.o_IsBillToClient || !fromportal)"
          >
            <div class="d-grid gap-2 col-6">
              <button
                cButton
                color="success"
                style="color: white"
                (click)="togglePayNowModal()"
              >
                Pay Now
              </button>
            </div>
          </c-col>

          <c-col
            [md]="6"
            class="d-flex justify-content-end"
            *ngIf="!InvoiceDetailsData?.isPaid && IsAdmin"
          >
            <div class="d-grid gap-2 col-6">
              <button
                cButton
                color="success"
                style="color: white"
                (click)="toggleMarkAsPaidModal()"
              >
                Mark As Paid
              </button>
            </div>
          </c-col>
        </c-row>

        <!-- <c-row class="mx-3 mt-4">
          <c-col [md]="12" class="text-center">
            <h4 style="font-weight: bold;margin: 0;">Invoice Details</h4>
          </c-col>
        </c-row> -->
        <c-row class="mx-3 mt-3">
          <c-col>
            <c-card class="mb-3">
              <c-card-header class="text-center">
                <h5>Invoice Details</h5>
              </c-card-header>
              <c-card-body>
                <div class="table-responsive">
                  <table cTable>
                    <thead>
                      <tr>
                        <th scope="col">Sr. No.</th>
                        <!-- <th scope="col">Product Name</th> -->
                        <th scope="col" class="text-start">Feature Name</th>
                        <th scope="col" class="text-end">Payment Cycle</th>
                        <th scope="col" class="text-end">Amount</th>
                        <th scope="col" class="text-end" *ngIf="InvoiceDetailsData?.extraStores > 0">Extra Stores Amount</th>
                        <!-- <th scope="col" class="text-end"  >One Time Amount</th> -->
                        <!-- <th scope="col">Price</th> -->
                        <!-- <th scope="col">Discount</th> -->
                        <th scope="col" class="text-end">Net Amount</th>
                        <!-- <th scope="col" class="text-end" *ngIf="!InvoiceDetailsData?.o_IsBillToClient || fromportal ">Partner Margin</th> -->
                        <!-- <th scope="col" class="text-end" >Service Item Margin</th> -->
                        <th scope="col" class="text-end" >Payable Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of InvoiceDetailsData?.invoice_Details;
                          let i = index
                        "
                      >
                        <td>{{ i + 1 }}</td>
                        <!-- <td>{{ item.productName }}</td>--> <!-- Product Name -->
                        <td>{{ item.featureName }}</td>  <!-- Feature Name -->
                        <td style="white-space: nowrap;">
                          {{ InvoiceDetailsData?.plD_Duration + " Months" }}
                        </td> <!-- Duration -->
                        <td class="text-end">
                          {{
                            item.price                               | currency
                          }}
                        </td> <!-- Amount -->
                        <!-- <td class="text-end">{{ item.price | currency }}</td> Price -->
                        <td class="text-end" *ngIf="InvoiceDetailsData?.extraStores > 0">
                          {{
                            item.price_ExtraStore | currency
                          }}
                        </td> <!--  Additional Store Amount -->
                        <!-- <td class="text-end">
                          {{ item.price_OneTime | currency }}
                        </td> One Time Amount -->
                        <!-- <td class="text-end">
                          {{
                            item.price * InvoiceDetailsData?.plD_Duration -
                              item.price * InvoiceDetailsData?.plD_ChargeDuration
                              | currency
                          }}
                        </td> --> <!-- Discount -->
                        <td class="text-end">
                          {{
                            item.price  +
                              item.price_OneTime + item.price_ExtraStore | currency
                          }}
                        </td> <!-- Net Amount -->
                        <!-- <td class="text-end" *ngIf="!InvoiceDetailsData?.o_IsBillToClient  || fromportal ">
                          @if (!item.o_IsServiceItem) {
                            {{
                              (item.price +
                                item.price_OneTime + item.price_ExtraStore) *
                                (InvoiceDetailsData?.partnerDiscountRate / 100)
                              | currency
                            }}
                          } @else {
                            {{
                              (item.price +
                                item.price_OneTime + item.price_ExtraStore) *
                                (InvoiceDetailsData?.o_PPkg_ServiceDiscountPercent / 100) | currency
                            }}
                          }
                        </td> Partner Margin -->
                        <!-- <td class="text-end">
                          @if (item.isServiceItem) {
                            {{
                              (item.price *
                                InvoiceDetailsData?.plD_ChargeDuration +
                                item.price_OneTime) *
                                (InvoiceDetailsData?.serviceDiscountRate / 100)
                              | currency
                            }}
                          } @else {
                            {{
                              0 | currency
                            }}
                          }
                          
                        </td> -->  <!-- Service Item Margin -->
                        <td class="text-end" *ngIf="InvoiceDetailsData?.o_IsBillToClient  && !fromportal ">
                          {{
                            (item.price ) +
                              (item.price_OneTime + item.price_ExtraStore) 
                              | currency
                          }}
                        </td> 
                        <td class="text-end" *ngIf="!InvoiceDetailsData?.o_IsBillToClient  || fromportal ">
                         
                         @if (!item.o_IsServiceItem) {
                         {{
                            (item.price ) +
                              (item.price_OneTime + item.price_ExtraStore) | currency
                          }}
                         }  @else
                         {
                          {{
                            (item.price ) +
                              (item.price_OneTime + item.price_ExtraStore) | currency
                          }}
                         }
                        </td> <!-- Payable Amount -->
                      </tr>
                      <tr>
                        <th colspan="8" class="text-end">Total Amount</th>
                        <td class="text-end">
                          {{ InvoiceDetailsData?.totalAmount | currency }}
                        </td>
                      </tr>
                      <tr>
                        <th colspan="8" class="text-end">Tax Amount</th>
                        <td class="text-end">
                          {{ InvoiceDetailsData?.totalTax | currency }}
                        </td>
                      </tr>
                      <!-- <tr *ngIf="!InvoiceDetailsData?.o_IsBillToClient  || fromportal ">
                        <th colspan="8" class="text-end">Partner Margin</th>
                        <td class="text-end">
                          {{ InvoiceDetailsData?.discountAmount | currency }}
                        </td>
                      </tr> -->
                      <!-- <tr *ngIf="!InvoiceDetailsData?.o_IsBillToClient  || fromportal ">
                        <th colspan="8" class="text-end">Service Item Margin</th>
                        <td class="text-end">
                          {{  InvoiceDetailsData?.srvDiscountAmount| currency }}
                        </td>
                      </tr> -->
                      <tr *ngIf="!InvoiceDetailsData?.o_IsBillToClient">
                        <th colspan="8" class="text-end">Payable Amount</th>
                        <td class="text-end">
                          {{
                            InvoiceDetailsData?.totalAmount -
                              InvoiceDetailsData?.discountAmount - InvoiceDetailsData?.srvDiscountAmount | currency
                          }}
                        </td>
                      </tr>
                      <tr *ngIf="InvoiceDetailsData?.o_IsBillToClient">
                        <th colspan="8" class="text-end">Payable Amount</th>
                        <td class="text-end">
                          {{
                            InvoiceDetailsData?.totalAmount | currency
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<!-- Mark As Paid modal -->
<c-modal
  id="MarkAsPaidModal"
  [visible]="visibleMarkAsPaidModal"
  backdrop="static"
  alignment="center"
>
  <c-modal-header>
    <h6 cModalTitle>Are you sure you want to mark this invoice as paid?</h6>
    <button (click)="toggleMarkAsPaidModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <form
      #MarkAsPaidForm="ngForm"
      (ngSubmit)="MarkAsPaid(MarkAsPaidForm)"
      [gutter]="3"
      [validated]="customStylesValidated"
      novalidate
      cForm
      cRow
      class="needs-validation"
    >
      <c-col [md]="12">
        <label for="paymentDate" class="mb-2">Payment Date *</label>
        <c-date-picker
          closeOnSelect
          name="paymentDate"
          required
          [maxDate]="TodaysDate"
          [(ngModel)]="InvoicedetailService.MarkAsPaidData.paymentDate"
        />
      </c-col>

      <c-col [md]="12">
        <label for="remarks" class="mb-2">Remarks *</label>
        <textarea
          cFormControl
          id="remarks"
          name="remarks"
          rows="3"
          required
          [(ngModel)]="InvoicedetailService.MarkAsPaidData.remarks"
        ></textarea>
        <!-- <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false">Role Name is Required</c-form-feedback> -->
      </c-col>
      <c-col [md]="12" *ngIf="Message">
        <c-alert fade color="danger" class="d-flex align-items-center mt-2">
          <svg cIcon size="xl" name="cilWarning"></svg>
          <div style="margin-left: 10px">
            <p class="mb-0">
              {{ Message }}
            </p>
          </div>
        </c-alert>
      </c-col>
      <c-col [xs]="12">
        <div class="text-end">
          <button cButton color="success" variant="outline" type="submit" [disabled]="ButtonLoading">
            <c-spinner
              aria-hidden="true"
              size="sm"
              *ngIf="ButtonLoading"
            ></c-spinner>
            Save
          </button>
        </div>
      </c-col>
    </form>
  </c-modal-body>
</c-modal>

<!-- Pay Now Modal -->
<c-modal
  id="PayNowModal"
  [visible]="visiblePayNowModal"
  backdrop="static"
  alignment="center"
  size="lg"
>
  <c-modal-header>
    <h6 cModalTitle>Enter Card Details</h6>
    <button (click)="togglePayNowModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <form
      [formGroup]="payNowForm"
      (ngSubmit)="onSubmit()"
      cForm
      [gutter]="2"
      cRow
    >
    <c-col [md]="12">
      <div class="text-start">
        <b class="text-medium-emphasis">Card Details</b>
      </div>
    </c-col>
      <!-- First Name and Last Name in One Line -->
      <c-col [md]="6">
        <div class="form-group">
          <label for="firstName">First Name *</label>
          <input
            type="text"
            id="firstName"
            formControlName="firstName"
            class="form-control"
            placeholder="First Name"
          />
          <div
            *ngIf="
              payNowForm.get('firstName')?.touched &&
              payNowForm.get('firstName')?.invalid
            "
            class="text-danger"
          >
            First Name is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="6">
        <div class="form-group">
          <label for="lastName">Last Name *</label>
          <input
            type="text"
            id="lastName"
            formControlName="lastName"
            class="form-control"
            placeholder="Last Name"
          />
          <div
            *ngIf="
              payNowForm.get('lastName')?.touched &&
              payNowForm.get('lastName')?.invalid
            "
            class="text-danger"
          >
            Last Name is required.
          </div>
        </div>
      </c-col>

      <!-- Card Number with Icon -->
      <c-col [md]="4">
        <div class="form-group position-relative">
          <label for="cardNumber">Card Number *</label>
          <input
            type="text"
            id="cardNumber"
            formControlName="cardNumber"
            class="form-control"
            placeholder="Enter Card Number"
            maxlength="16"
          />
          <div class="card-icon position-absolute" *ngIf="cardType">
            <img
              [src]="cardTypeIcon"
              [alt]="cardType"
              class="card-icon-img"
              style="width: 40px; height: 25px"
            />
          </div>
          <div
            *ngIf="
              payNowForm.get('cardNumber')?.touched &&
              payNowForm.get('cardNumber')?.invalid
            "
            class="text-danger"
          >
            Card Number is required and must be 16 digits.
          </div>
        </div>
      </c-col>
      <!-- Expiry (MM and YY) and CVV Code in One Line -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="expiryMonth">Expiry Month (MM) *</label>
          <input
            type="text"
            id="expiryMonth"
            formControlName="expiryMonth"
            class="form-control"
            placeholder="MM"
            maxlength="2"
          />
          <div
            *ngIf="
              payNowForm.get('expiryMonth')?.touched &&
              payNowForm.get('expiryMonth')?.invalid
            "
            class="text-danger"
          >
            Expiry Month is required and must be between 01 and 12.
          </div>
        </div>
      </c-col>
      <c-col [md]="3">
        <div class="form-group">
          <label for="expiryYear">Expiry Year (YY) *</label>
          <input
            type="text"
            id="expiryYear"
            formControlName="expiryYear"
            class="form-control"
            placeholder="YY"
            maxlength="2"
          />
          <div
            *ngIf="
              payNowForm.get('expiryYear')?.touched &&
              payNowForm.get('expiryYear')?.invalid
            "
            class="text-danger"
          >
            Expiry Year is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="2">
        <div class="form-group">
          <label for="cvv">CVV Code *</label>
          <input
            type="password"
            id="cvv"
            formControlName="cvv"
            class="form-control"
            placeholder="CVV"
            maxlength="3"
          />
          <div
            *ngIf="
              payNowForm.get('cvv')?.touched && payNowForm.get('cvv')?.invalid
            "
            class="text-danger"
          >
            CVV Code is required and must be 3 digits.
          </div>
        </div>
      </c-col>
     
      <c-col [md]="12">
        <div class="text-start">
          <b class="text-medium-emphasis">Billing Address</b> 
          <div class="input-group">
            <c-form-check [switch]="true">
              <input
                cFormCheckInput
                type="checkbox"
                required
                id="termss"
                name="termss"
                [(ngModel)]="EditBusinessInformation"
                [ngModelOptions]="{standalone: true}"
                (click)="onChangedBusinessInformation($event)"
              />
              <label cFormCheckLabel style="font-size: 14px"
                >Change Billing Address On Card.</label
              >
            </c-form-check>
          </div>
        </div>
      </c-col>

      <!-- First Name and Last Name in One Line -->
      <!-- <c-col [md]="12">
        <div class="form-group">
          <label for="firstNamebilling">Legal Name *</label>
          <input
            type="text"
            id="firstNamebilling"
            formControlName="firstNamebilling"
            class="form-control"
            placeholder="Legal Name"
            cFormControl
          />
          <div
            *ngIf="
              payNowForm.get('firstNamebilling')?.touched &&
              payNowForm.get('firstNamebilling')?.invalid
            "
            class="text-danger"
          >
            First Name is required.
          </div>
        </div>
      </c-col> -->
      <!-- <c-col [md]="6">
        <div class="form-group">
          <label for="lastNamebilling">Last Name *</label>
          <input
            type="text"
            id="lastNamebilling"
            formControlName="lastNamebilling"
            class="form-control"
            placeholder="Last Name"
          />
          <div
            *ngIf="
              payNowForm.get('lastNamebilling')?.touched &&
              payNowForm.get('lastNamebilling')?.invalid
            "
            class="text-danger"
          >
            Last Name is required.
          </div>
        </div>
      </c-col> -->

      <!-- Address Line 1 -->
      <c-col [md]="12">
        <div class="form-group">
          <label for="addressLine1">Address *</label>
          <input
            type="text"
            id="addressLine1"
            formControlName="addressLine1"
            class="form-control"
            placeholder="Address Line 1"
          />
          <div
            *ngIf="
              payNowForm.get('addressLine1')?.touched &&
              payNowForm.get('addressLine1')?.invalid
            "
            class="text-danger"
          >
            Address Line 1 is required.
          </div>
        </div>
      </c-col>


      <!-- Address Line 2 -->
      <!-- <c-col [md]="6">
        <div class="form-group">
          <label for="addressLine2">Address Line 2 *</label>
          <input
            type="text"
            id="addressLine2"
            formControlName="addressLine2"
            class="form-control"
            placeholder="Address Line 2"
          />
          <div
            *ngIf="
              payNowForm.get('addressLine2')?.touched &&
              payNowForm.get('addressLine2')?.invalid
            "
            class="text-danger"
          >
            Address Line 2 is required.
          </div>
        </div>
      </c-col> -->

      <!-- State -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="state">State *</label>
          <input
            type="text"
            id="state"
            formControlName="state"
            class="form-control"
            placeholder="State"
          />
          <div
            *ngIf="
              payNowForm.get('state')?.touched &&
              payNowForm.get('state')?.invalid
            "
            class="text-danger"
          >
            State is required.
          </div>
        </div>
      </c-col>

      <!-- City -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="city">City *</label>
          <input
            type="text"
            id="city"
            formControlName="city"
            class="form-control"
            placeholder="City"
          />
          <div
            *ngIf="
              payNowForm.get('city')?.touched &&
              payNowForm.get('city')?.invalid
            "
            class="text-danger"
          >
            City is required.
          </div>
        </div>
      </c-col>

      <!-- Zip Code -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="zipCode">Zip/Postal Code *</label>
          <input
            type="text"
            id="zipCode"
            formControlName="zipCode"
            class="form-control"
            placeholder="Zip Code"
          />
          <div
            *ngIf="
              payNowForm.get('zipCode')?.touched &&
              payNowForm.get('zipCode')?.invalid
            "
            class="text-danger"
          >
            Zip Code is required.
          </div>
        </div>
      </c-col>

      <!-- Country -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="country">Country *</label>
          <input
            type="text"
            id="country"
            formControlName="country"
            class="form-control"
            placeholder="Country"
          />
          <div
            *ngIf="
              payNowForm.get('country')?.touched &&
              payNowForm.get('country')?.invalid
            "
            class="text-danger"
          >
            Country is required.
          </div>
        </div>
      </c-col>

      <!-- Submit Button -->
      <div class="form-group text-center mt-2">
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="payNowForm.invalid || ButtonLoading"
          
        >
        <c-spinner
        aria-hidden="true"
        size="sm"
        *ngIf="ButtonLoading"
        ></c-spinner>
        Pay Now
        </button>
      </div>
    </form>
  </c-modal-body>
</c-modal>
